/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Next_Event_Aria_LabelInputs */

const en_player_next_event_aria_label = /** @type {(inputs: Player_Next_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Event`)
};

const fr_player_next_event_aria_label = /** @type {(inputs: Player_Next_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement Suivant`)
};

const de_player_next_event_aria_label = /** @type {(inputs: Player_Next_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Veranstaltung`)
};

const it_player_next_event_aria_label = /** @type {(inputs: Player_Next_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo evento`)
};

const ru_player_next_event_aria_label = /** @type {(inputs: Player_Next_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующее событие`)
};

const es_player_next_event_aria_label = /** @type {(inputs: Player_Next_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo evento`)
};

const zh_cn2_player_next_event_aria_label = /** @type {(inputs: Player_Next_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个活动`)
};

const ja_player_next_event_aria_label = /** @type {(inputs: Player_Next_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベント`)
};

const hi_player_next_event_aria_label = /** @type {(inputs: Player_Next_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगली घटना`)
};

const pt_pt2_player_next_event_aria_label = /** @type {(inputs: Player_Next_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo evento`)
};

/**
* | output |
* | --- |
* | "Next Event" |
*
* @param {Player_Next_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_next_event_aria_label = /** @type {((inputs?: Player_Next_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Next_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_next_event_aria_label(inputs)
	if (locale === "de") return de_player_next_event_aria_label(inputs)
	if (locale === "it") return it_player_next_event_aria_label(inputs)
	if (locale === "ru") return ru_player_next_event_aria_label(inputs)
	if (locale === "es") return es_player_next_event_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_next_event_aria_label(inputs)
	if (locale === "ja") return ja_player_next_event_aria_label(inputs)
	if (locale === "hi") return hi_player_next_event_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_next_event_aria_label(inputs)
	return en_player_next_event_aria_label(inputs)
});